import styled from '@emotion/styled';
export const LoaderContainer = styled.div`
    height: 150px;
`;
